import { Button, Space } from '@arco-design/web-react';
import { usePhoneStore } from '../store/phone';
import { maskPhone } from '../utils/format';

/**
 * 忙时同事邀请卡片：只消费 kind=invite，禁止当新客户弹屏。
 * 三动作：忽略（只挂邀请腿）/ 保持当前并接 / 挂断当前并接。
 * 邀请附言 note 可选，旧引擎不带则不展示。
 */
export default function InviteCard() {
  const invite = usePhoneStore((s) => s.invite);
  const status = usePhoneStore((s) => s.status);
  const engine = usePhoneStore((s) => s.engine);
  const dismissInvite = usePhoneStore((s) => s.dismissInvite);
  const acceptInvite = usePhoneStore((s) => s.acceptInvite);
  if (!invite || engine !== 'zitch') return null;
  const busy = status === 'in-call' || status === 'ringing-in' || status === 'ringing-out';
  const who = maskPhone(invite.from) || invite.from || '同事';
  return (
    <div className="bcc-invite-card" role="status" aria-label="同事邀请">
      <div className="bcc-invite-card__title">{who} 邀请你加入</div>
      {invite.note ? <div className="bcc-invite-card__note">{invite.note}</div> : null}
      <Space size={8} wrap>
        <Button size="small" onClick={() => dismissInvite()}>
          忽略
        </Button>
        {busy ? (
          <>
            <Button size="small" type="primary" onClick={() => void acceptInvite('hold')}>
              保持当前并接听
            </Button>
            <Button size="small" status="danger" onClick={() => void acceptInvite('hangup')}>
              挂断当前并接听
            </Button>
          </>
        ) : (
          <Button size="small" type="primary" onClick={() => void acceptInvite('answer')}>
            接听
          </Button>
        )}
      </Space>
    </div>
  );
}
